import { RiMenuFoldFill } from "react-icons/ri";
import { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";

const Navbar = ({
    isCollapsed,
    toggleSidebar,
    isSidebarVisible,
    title,
    SubPage
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const modalRef = useRef(null);
    const studentInformation = useSelector((state) => state.auth.studentData);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsModalOpen(false);
            }
        };

        if (isModalOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isModalOpen]);

    return (
        <>
            <div className={`admin-navbar-container ${isCollapsed ? "admin-navbar-collapsed" : "admin-navbar-expanded"}`}>
                <div className="admin-navbar-left">
                    <div className="sidebar-header">
                        <img 
                            src="https://campus.acetians.in/custom/images/1722342842lalitpurlogo.png" 
                            alt="Logo" 
                            className="sidebar-logo" 
                        />
                        {!isCollapsed && (
                            <div className="sidebar-brand">
                                <h1 className="sidebar-brand-title">Student Portal</h1>
                            </div>
                        )}
                    </div>
                </div>

                <div className="admin-navbar-right">
                    <div className="admin-navbar-page-info">
                          <span>{studentInformation.name}</span>
                         <div className='header-user-image'>
            <img src={studentInformation.profile_photo || "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQopM4QKvbSkmj_0CStR29IIHPekjzSKhzLNl0CatOSpw&s=10" }/>
          </div>
                   
                    </div>
                    
                  
                </div>
            </div>
        </>
    );
};

export default Navbar